var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPaymentRequest = function SvgPaymentRequest(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7855 11.7248V2.10714C17.7855 1.74721 17.6426 1.40201 17.388 1.1475C17.1335 0.892984 16.7883 0.75 16.4284 0.75H5.57125C5.21132 0.75 4.86612 0.892984 4.61161 1.1475C4.3571 1.40201 4.21411 1.74721 4.21411 2.10714V11.7248",
    stroke: "#8290A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3998 10.4447C19.4997 10.3655 19.62 10.316 19.7467 10.302C19.8734 10.2879 20.0016 10.3099 20.1164 10.3653C20.2313 10.4208 20.3282 10.5074 20.396 10.6154C20.4638 10.7234 20.4999 10.8483 20.5 10.9758V19.752C20.5 20.112 20.357 20.4572 20.1025 20.7117C19.848 20.9662 19.5028 21.1092 19.1429 21.1092H2.85714C2.49721 21.1092 2.15201 20.9662 1.8975 20.7117C1.64298 20.4572 1.5 20.112 1.5 19.752V10.9758C1.50011 10.8483 1.53616 10.7234 1.604 10.6154C1.67184 10.5074 1.76874 10.4208 1.88358 10.3653C1.99842 10.3099 2.12656 10.2879 2.2533 10.302C2.38005 10.316 2.50027 10.3655 2.60019 10.4447L9.32348 15.7774C9.80162 16.1529 10.392 16.3571 11 16.3571C11.608 16.3571 12.1984 16.1529 12.6765 15.7774L19.3998 10.4447Z",
    stroke: "#8290A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4456 14.374L17.1074 17.0358",
    stroke: "#8290A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55463 14.374L4.89282 17.0358",
    stroke: "#8290A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.181 9.20416C11.3769 9.46151 11.632 9.66784 11.9246 9.80565C12.2173 9.94346 12.5388 10.0087 12.862 9.99582C13.8925 9.99582 14.7285 9.36882 14.7285 8.59616C14.7285 7.82349 13.8952 7.19739 12.8656 7.19739C11.836 7.19739 11 6.57039 11 5.79682C11 5.02325 11.836 4.39716 12.8656 4.39716C13.1889 4.38406 13.5105 4.44919 13.8031 4.58702C14.0958 4.72485 14.3509 4.9313 14.5467 5.18882",
    stroke: "#8290A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8657 9.99512V10.9279",
    stroke: "#8290A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8657 3.46387V4.39668",
    stroke: "#8290A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92871 4.14258H8.28585",
    stroke: "#8290A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92871 6.85742H8.28585",
    stroke: "#8290A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92871 9.57129H8.28585",
    stroke: "#8290A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaymentRequest, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/payment-request.c2502c60.svg";
export { ForwardRef as ReactComponent };